import { isUnknownObject } from '~/shared/utils/guards'
import { BaseModel, fillOwnProperties } from '~/shared/model'

export default class CompanyInfoModel extends BaseModel {
  static override constructorName = 'CompanyInfoModel'

  public name: string = ''
  public phone: string = ''
  public email: string = ''

  constructor(data?: unknown) {
    super(data)
    if (isUnknownObject(data)) {
      fillOwnProperties(this, data)
    }
  }
}
